/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as WomenImport } from './routes/women'
import { Route as UnitsImport } from './routes/units'
import { Route as StudentsImport } from './routes/students'
import { Route as ProductsImport } from './routes/products'
import { Route as LearningPathsImport } from './routes/learning-paths'
import { Route as JourneysImport } from './routes/journeys'
import { Route as IdentityReviewsImport } from './routes/identity-reviews'
import { Route as GroupsImport } from './routes/groups'
import { Route as GrammarVideosImport } from './routes/grammar-videos'
import { Route as FeedbackImport } from './routes/feedback'
import { Route as EventsImport } from './routes/events'
import { Route as ConversationTopicsImport } from './routes/conversation-topics'
import { Route as ClassesImport } from './routes/classes'
import { Route as AnnouncementsImport } from './routes/announcements'
import { Route as AnalyticsImport } from './routes/analytics'
import { Route as AboutImport } from './routes/about'
import { Route as AbilitiesImport } from './routes/abilities'
import { Route as AppRouteImport } from './routes/app/route'
import { Route as IndexImport } from './routes/index'
import { Route as WomenNewImport } from './routes/women/new'
import { Route as WomenWomanIdImport } from './routes/women/$womanId'
import { Route as UnitsNewImport } from './routes/units/new'
import { Route as UnitsUnitIdImport } from './routes/units/$unitId'
import { Route as StudentsNewImport } from './routes/students/new'
import { Route as StudentsStudentIdImport } from './routes/students/$studentId'
import { Route as ProductsNewImport } from './routes/products/new'
import { Route as ProductsProductIdImport } from './routes/products/$productId'
import { Route as LearningPathsNewImport } from './routes/learning-paths/new'
import { Route as LearningPathsPathIdImport } from './routes/learning-paths/$pathId'
import { Route as JourneysNewImport } from './routes/journeys/new'
import { Route as JourneysJourneyIdImport } from './routes/journeys/$journeyId'
import { Route as GroupsNewImport } from './routes/groups/new'
import { Route as GroupsGroupIdImport } from './routes/groups/$groupId'
import { Route as FeedbackNewImport } from './routes/feedback/new'
import { Route as FeedbackCampaignIdImport } from './routes/feedback/$campaignId'
import { Route as ClassesNewImport } from './routes/classes/new'
import { Route as ClassesClassIdImport } from './routes/classes/$classId'
import { Route as AnnouncementsNewImport } from './routes/announcements/new'
import { Route as AnnouncementsAnnouncementIdImport } from './routes/announcements/$announcementId'

// Create/Update Routes

const WomenRoute = WomenImport.update({
  id: '/women',
  path: '/women',
  getParentRoute: () => rootRoute,
} as any)

const UnitsRoute = UnitsImport.update({
  id: '/units',
  path: '/units',
  getParentRoute: () => rootRoute,
} as any)

const StudentsRoute = StudentsImport.update({
  id: '/students',
  path: '/students',
  getParentRoute: () => rootRoute,
} as any)

const ProductsRoute = ProductsImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => rootRoute,
} as any)

const LearningPathsRoute = LearningPathsImport.update({
  id: '/learning-paths',
  path: '/learning-paths',
  getParentRoute: () => rootRoute,
} as any)

const JourneysRoute = JourneysImport.update({
  id: '/journeys',
  path: '/journeys',
  getParentRoute: () => rootRoute,
} as any)

const IdentityReviewsRoute = IdentityReviewsImport.update({
  id: '/identity-reviews',
  path: '/identity-reviews',
  getParentRoute: () => rootRoute,
} as any)

const GroupsRoute = GroupsImport.update({
  id: '/groups',
  path: '/groups',
  getParentRoute: () => rootRoute,
} as any)

const GrammarVideosRoute = GrammarVideosImport.update({
  id: '/grammar-videos',
  path: '/grammar-videos',
  getParentRoute: () => rootRoute,
} as any)

const FeedbackRoute = FeedbackImport.update({
  id: '/feedback',
  path: '/feedback',
  getParentRoute: () => rootRoute,
} as any)

const EventsRoute = EventsImport.update({
  id: '/events',
  path: '/events',
  getParentRoute: () => rootRoute,
} as any)

const ConversationTopicsRoute = ConversationTopicsImport.update({
  id: '/conversation-topics',
  path: '/conversation-topics',
  getParentRoute: () => rootRoute,
} as any)

const ClassesRoute = ClassesImport.update({
  id: '/classes',
  path: '/classes',
  getParentRoute: () => rootRoute,
} as any)

const AnnouncementsRoute = AnnouncementsImport.update({
  id: '/announcements',
  path: '/announcements',
  getParentRoute: () => rootRoute,
} as any)

const AnalyticsRoute = AnalyticsImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => rootRoute,
} as any)

const AboutRoute = AboutImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRoute,
} as any)

const AbilitiesRoute = AbilitiesImport.update({
  id: '/abilities',
  path: '/abilities',
  getParentRoute: () => rootRoute,
} as any)

const AppRouteRoute = AppRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const WomenNewRoute = WomenNewImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => WomenRoute,
} as any)

const WomenWomanIdRoute = WomenWomanIdImport.update({
  id: '/$womanId',
  path: '/$womanId',
  getParentRoute: () => WomenRoute,
} as any)

const UnitsNewRoute = UnitsNewImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => UnitsRoute,
} as any)

const UnitsUnitIdRoute = UnitsUnitIdImport.update({
  id: '/$unitId',
  path: '/$unitId',
  getParentRoute: () => UnitsRoute,
} as any)

const StudentsNewRoute = StudentsNewImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => StudentsRoute,
} as any)

const StudentsStudentIdRoute = StudentsStudentIdImport.update({
  id: '/$studentId',
  path: '/$studentId',
  getParentRoute: () => StudentsRoute,
} as any)

const ProductsNewRoute = ProductsNewImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => ProductsRoute,
} as any)

const ProductsProductIdRoute = ProductsProductIdImport.update({
  id: '/$productId',
  path: '/$productId',
  getParentRoute: () => ProductsRoute,
} as any)

const LearningPathsNewRoute = LearningPathsNewImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => LearningPathsRoute,
} as any)

const LearningPathsPathIdRoute = LearningPathsPathIdImport.update({
  id: '/$pathId',
  path: '/$pathId',
  getParentRoute: () => LearningPathsRoute,
} as any)

const JourneysNewRoute = JourneysNewImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => JourneysRoute,
} as any)

const JourneysJourneyIdRoute = JourneysJourneyIdImport.update({
  id: '/$journeyId',
  path: '/$journeyId',
  getParentRoute: () => JourneysRoute,
} as any)

const GroupsNewRoute = GroupsNewImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => GroupsRoute,
} as any)

const GroupsGroupIdRoute = GroupsGroupIdImport.update({
  id: '/$groupId',
  path: '/$groupId',
  getParentRoute: () => GroupsRoute,
} as any)

const FeedbackNewRoute = FeedbackNewImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => FeedbackRoute,
} as any)

const FeedbackCampaignIdRoute = FeedbackCampaignIdImport.update({
  id: '/$campaignId',
  path: '/$campaignId',
  getParentRoute: () => FeedbackRoute,
} as any)

const ClassesNewRoute = ClassesNewImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => ClassesRoute,
} as any)

const ClassesClassIdRoute = ClassesClassIdImport.update({
  id: '/$classId',
  path: '/$classId',
  getParentRoute: () => ClassesRoute,
} as any)

const AnnouncementsNewRoute = AnnouncementsNewImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AnnouncementsRoute,
} as any)

const AnnouncementsAnnouncementIdRoute =
  AnnouncementsAnnouncementIdImport.update({
    id: '/$announcementId',
    path: '/$announcementId',
    getParentRoute: () => AnnouncementsRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRoute
    }
    '/abilities': {
      id: '/abilities'
      path: '/abilities'
      fullPath: '/abilities'
      preLoaderRoute: typeof AbilitiesImport
      parentRoute: typeof rootRoute
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutImport
      parentRoute: typeof rootRoute
    }
    '/analytics': {
      id: '/analytics'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AnalyticsImport
      parentRoute: typeof rootRoute
    }
    '/announcements': {
      id: '/announcements'
      path: '/announcements'
      fullPath: '/announcements'
      preLoaderRoute: typeof AnnouncementsImport
      parentRoute: typeof rootRoute
    }
    '/classes': {
      id: '/classes'
      path: '/classes'
      fullPath: '/classes'
      preLoaderRoute: typeof ClassesImport
      parentRoute: typeof rootRoute
    }
    '/conversation-topics': {
      id: '/conversation-topics'
      path: '/conversation-topics'
      fullPath: '/conversation-topics'
      preLoaderRoute: typeof ConversationTopicsImport
      parentRoute: typeof rootRoute
    }
    '/events': {
      id: '/events'
      path: '/events'
      fullPath: '/events'
      preLoaderRoute: typeof EventsImport
      parentRoute: typeof rootRoute
    }
    '/feedback': {
      id: '/feedback'
      path: '/feedback'
      fullPath: '/feedback'
      preLoaderRoute: typeof FeedbackImport
      parentRoute: typeof rootRoute
    }
    '/grammar-videos': {
      id: '/grammar-videos'
      path: '/grammar-videos'
      fullPath: '/grammar-videos'
      preLoaderRoute: typeof GrammarVideosImport
      parentRoute: typeof rootRoute
    }
    '/groups': {
      id: '/groups'
      path: '/groups'
      fullPath: '/groups'
      preLoaderRoute: typeof GroupsImport
      parentRoute: typeof rootRoute
    }
    '/identity-reviews': {
      id: '/identity-reviews'
      path: '/identity-reviews'
      fullPath: '/identity-reviews'
      preLoaderRoute: typeof IdentityReviewsImport
      parentRoute: typeof rootRoute
    }
    '/journeys': {
      id: '/journeys'
      path: '/journeys'
      fullPath: '/journeys'
      preLoaderRoute: typeof JourneysImport
      parentRoute: typeof rootRoute
    }
    '/learning-paths': {
      id: '/learning-paths'
      path: '/learning-paths'
      fullPath: '/learning-paths'
      preLoaderRoute: typeof LearningPathsImport
      parentRoute: typeof rootRoute
    }
    '/products': {
      id: '/products'
      path: '/products'
      fullPath: '/products'
      preLoaderRoute: typeof ProductsImport
      parentRoute: typeof rootRoute
    }
    '/students': {
      id: '/students'
      path: '/students'
      fullPath: '/students'
      preLoaderRoute: typeof StudentsImport
      parentRoute: typeof rootRoute
    }
    '/units': {
      id: '/units'
      path: '/units'
      fullPath: '/units'
      preLoaderRoute: typeof UnitsImport
      parentRoute: typeof rootRoute
    }
    '/women': {
      id: '/women'
      path: '/women'
      fullPath: '/women'
      preLoaderRoute: typeof WomenImport
      parentRoute: typeof rootRoute
    }
    '/announcements/$announcementId': {
      id: '/announcements/$announcementId'
      path: '/$announcementId'
      fullPath: '/announcements/$announcementId'
      preLoaderRoute: typeof AnnouncementsAnnouncementIdImport
      parentRoute: typeof AnnouncementsImport
    }
    '/announcements/new': {
      id: '/announcements/new'
      path: '/new'
      fullPath: '/announcements/new'
      preLoaderRoute: typeof AnnouncementsNewImport
      parentRoute: typeof AnnouncementsImport
    }
    '/classes/$classId': {
      id: '/classes/$classId'
      path: '/$classId'
      fullPath: '/classes/$classId'
      preLoaderRoute: typeof ClassesClassIdImport
      parentRoute: typeof ClassesImport
    }
    '/classes/new': {
      id: '/classes/new'
      path: '/new'
      fullPath: '/classes/new'
      preLoaderRoute: typeof ClassesNewImport
      parentRoute: typeof ClassesImport
    }
    '/feedback/$campaignId': {
      id: '/feedback/$campaignId'
      path: '/$campaignId'
      fullPath: '/feedback/$campaignId'
      preLoaderRoute: typeof FeedbackCampaignIdImport
      parentRoute: typeof FeedbackImport
    }
    '/feedback/new': {
      id: '/feedback/new'
      path: '/new'
      fullPath: '/feedback/new'
      preLoaderRoute: typeof FeedbackNewImport
      parentRoute: typeof FeedbackImport
    }
    '/groups/$groupId': {
      id: '/groups/$groupId'
      path: '/$groupId'
      fullPath: '/groups/$groupId'
      preLoaderRoute: typeof GroupsGroupIdImport
      parentRoute: typeof GroupsImport
    }
    '/groups/new': {
      id: '/groups/new'
      path: '/new'
      fullPath: '/groups/new'
      preLoaderRoute: typeof GroupsNewImport
      parentRoute: typeof GroupsImport
    }
    '/journeys/$journeyId': {
      id: '/journeys/$journeyId'
      path: '/$journeyId'
      fullPath: '/journeys/$journeyId'
      preLoaderRoute: typeof JourneysJourneyIdImport
      parentRoute: typeof JourneysImport
    }
    '/journeys/new': {
      id: '/journeys/new'
      path: '/new'
      fullPath: '/journeys/new'
      preLoaderRoute: typeof JourneysNewImport
      parentRoute: typeof JourneysImport
    }
    '/learning-paths/$pathId': {
      id: '/learning-paths/$pathId'
      path: '/$pathId'
      fullPath: '/learning-paths/$pathId'
      preLoaderRoute: typeof LearningPathsPathIdImport
      parentRoute: typeof LearningPathsImport
    }
    '/learning-paths/new': {
      id: '/learning-paths/new'
      path: '/new'
      fullPath: '/learning-paths/new'
      preLoaderRoute: typeof LearningPathsNewImport
      parentRoute: typeof LearningPathsImport
    }
    '/products/$productId': {
      id: '/products/$productId'
      path: '/$productId'
      fullPath: '/products/$productId'
      preLoaderRoute: typeof ProductsProductIdImport
      parentRoute: typeof ProductsImport
    }
    '/products/new': {
      id: '/products/new'
      path: '/new'
      fullPath: '/products/new'
      preLoaderRoute: typeof ProductsNewImport
      parentRoute: typeof ProductsImport
    }
    '/students/$studentId': {
      id: '/students/$studentId'
      path: '/$studentId'
      fullPath: '/students/$studentId'
      preLoaderRoute: typeof StudentsStudentIdImport
      parentRoute: typeof StudentsImport
    }
    '/students/new': {
      id: '/students/new'
      path: '/new'
      fullPath: '/students/new'
      preLoaderRoute: typeof StudentsNewImport
      parentRoute: typeof StudentsImport
    }
    '/units/$unitId': {
      id: '/units/$unitId'
      path: '/$unitId'
      fullPath: '/units/$unitId'
      preLoaderRoute: typeof UnitsUnitIdImport
      parentRoute: typeof UnitsImport
    }
    '/units/new': {
      id: '/units/new'
      path: '/new'
      fullPath: '/units/new'
      preLoaderRoute: typeof UnitsNewImport
      parentRoute: typeof UnitsImport
    }
    '/women/$womanId': {
      id: '/women/$womanId'
      path: '/$womanId'
      fullPath: '/women/$womanId'
      preLoaderRoute: typeof WomenWomanIdImport
      parentRoute: typeof WomenImport
    }
    '/women/new': {
      id: '/women/new'
      path: '/new'
      fullPath: '/women/new'
      preLoaderRoute: typeof WomenNewImport
      parentRoute: typeof WomenImport
    }
  }
}

// Create and export the route tree

interface AnnouncementsRouteChildren {
  AnnouncementsAnnouncementIdRoute: typeof AnnouncementsAnnouncementIdRoute
  AnnouncementsNewRoute: typeof AnnouncementsNewRoute
}

const AnnouncementsRouteChildren: AnnouncementsRouteChildren = {
  AnnouncementsAnnouncementIdRoute: AnnouncementsAnnouncementIdRoute,
  AnnouncementsNewRoute: AnnouncementsNewRoute,
}

const AnnouncementsRouteWithChildren = AnnouncementsRoute._addFileChildren(
  AnnouncementsRouteChildren,
)

interface ClassesRouteChildren {
  ClassesClassIdRoute: typeof ClassesClassIdRoute
  ClassesNewRoute: typeof ClassesNewRoute
}

const ClassesRouteChildren: ClassesRouteChildren = {
  ClassesClassIdRoute: ClassesClassIdRoute,
  ClassesNewRoute: ClassesNewRoute,
}

const ClassesRouteWithChildren =
  ClassesRoute._addFileChildren(ClassesRouteChildren)

interface FeedbackRouteChildren {
  FeedbackCampaignIdRoute: typeof FeedbackCampaignIdRoute
  FeedbackNewRoute: typeof FeedbackNewRoute
}

const FeedbackRouteChildren: FeedbackRouteChildren = {
  FeedbackCampaignIdRoute: FeedbackCampaignIdRoute,
  FeedbackNewRoute: FeedbackNewRoute,
}

const FeedbackRouteWithChildren = FeedbackRoute._addFileChildren(
  FeedbackRouteChildren,
)

interface GroupsRouteChildren {
  GroupsGroupIdRoute: typeof GroupsGroupIdRoute
  GroupsNewRoute: typeof GroupsNewRoute
}

const GroupsRouteChildren: GroupsRouteChildren = {
  GroupsGroupIdRoute: GroupsGroupIdRoute,
  GroupsNewRoute: GroupsNewRoute,
}

const GroupsRouteWithChildren =
  GroupsRoute._addFileChildren(GroupsRouteChildren)

interface JourneysRouteChildren {
  JourneysJourneyIdRoute: typeof JourneysJourneyIdRoute
  JourneysNewRoute: typeof JourneysNewRoute
}

const JourneysRouteChildren: JourneysRouteChildren = {
  JourneysJourneyIdRoute: JourneysJourneyIdRoute,
  JourneysNewRoute: JourneysNewRoute,
}

const JourneysRouteWithChildren = JourneysRoute._addFileChildren(
  JourneysRouteChildren,
)

interface LearningPathsRouteChildren {
  LearningPathsPathIdRoute: typeof LearningPathsPathIdRoute
  LearningPathsNewRoute: typeof LearningPathsNewRoute
}

const LearningPathsRouteChildren: LearningPathsRouteChildren = {
  LearningPathsPathIdRoute: LearningPathsPathIdRoute,
  LearningPathsNewRoute: LearningPathsNewRoute,
}

const LearningPathsRouteWithChildren = LearningPathsRoute._addFileChildren(
  LearningPathsRouteChildren,
)

interface ProductsRouteChildren {
  ProductsProductIdRoute: typeof ProductsProductIdRoute
  ProductsNewRoute: typeof ProductsNewRoute
}

const ProductsRouteChildren: ProductsRouteChildren = {
  ProductsProductIdRoute: ProductsProductIdRoute,
  ProductsNewRoute: ProductsNewRoute,
}

const ProductsRouteWithChildren = ProductsRoute._addFileChildren(
  ProductsRouteChildren,
)

interface StudentsRouteChildren {
  StudentsStudentIdRoute: typeof StudentsStudentIdRoute
  StudentsNewRoute: typeof StudentsNewRoute
}

const StudentsRouteChildren: StudentsRouteChildren = {
  StudentsStudentIdRoute: StudentsStudentIdRoute,
  StudentsNewRoute: StudentsNewRoute,
}

const StudentsRouteWithChildren = StudentsRoute._addFileChildren(
  StudentsRouteChildren,
)

interface UnitsRouteChildren {
  UnitsUnitIdRoute: typeof UnitsUnitIdRoute
  UnitsNewRoute: typeof UnitsNewRoute
}

const UnitsRouteChildren: UnitsRouteChildren = {
  UnitsUnitIdRoute: UnitsUnitIdRoute,
  UnitsNewRoute: UnitsNewRoute,
}

const UnitsRouteWithChildren = UnitsRoute._addFileChildren(UnitsRouteChildren)

interface WomenRouteChildren {
  WomenWomanIdRoute: typeof WomenWomanIdRoute
  WomenNewRoute: typeof WomenNewRoute
}

const WomenRouteChildren: WomenRouteChildren = {
  WomenWomanIdRoute: WomenWomanIdRoute,
  WomenNewRoute: WomenNewRoute,
}

const WomenRouteWithChildren = WomenRoute._addFileChildren(WomenRouteChildren)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/app': typeof AppRouteRoute
  '/abilities': typeof AbilitiesRoute
  '/about': typeof AboutRoute
  '/analytics': typeof AnalyticsRoute
  '/announcements': typeof AnnouncementsRouteWithChildren
  '/classes': typeof ClassesRouteWithChildren
  '/conversation-topics': typeof ConversationTopicsRoute
  '/events': typeof EventsRoute
  '/feedback': typeof FeedbackRouteWithChildren
  '/grammar-videos': typeof GrammarVideosRoute
  '/groups': typeof GroupsRouteWithChildren
  '/identity-reviews': typeof IdentityReviewsRoute
  '/journeys': typeof JourneysRouteWithChildren
  '/learning-paths': typeof LearningPathsRouteWithChildren
  '/products': typeof ProductsRouteWithChildren
  '/students': typeof StudentsRouteWithChildren
  '/units': typeof UnitsRouteWithChildren
  '/women': typeof WomenRouteWithChildren
  '/announcements/$announcementId': typeof AnnouncementsAnnouncementIdRoute
  '/announcements/new': typeof AnnouncementsNewRoute
  '/classes/$classId': typeof ClassesClassIdRoute
  '/classes/new': typeof ClassesNewRoute
  '/feedback/$campaignId': typeof FeedbackCampaignIdRoute
  '/feedback/new': typeof FeedbackNewRoute
  '/groups/$groupId': typeof GroupsGroupIdRoute
  '/groups/new': typeof GroupsNewRoute
  '/journeys/$journeyId': typeof JourneysJourneyIdRoute
  '/journeys/new': typeof JourneysNewRoute
  '/learning-paths/$pathId': typeof LearningPathsPathIdRoute
  '/learning-paths/new': typeof LearningPathsNewRoute
  '/products/$productId': typeof ProductsProductIdRoute
  '/products/new': typeof ProductsNewRoute
  '/students/$studentId': typeof StudentsStudentIdRoute
  '/students/new': typeof StudentsNewRoute
  '/units/$unitId': typeof UnitsUnitIdRoute
  '/units/new': typeof UnitsNewRoute
  '/women/$womanId': typeof WomenWomanIdRoute
  '/women/new': typeof WomenNewRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/app': typeof AppRouteRoute
  '/abilities': typeof AbilitiesRoute
  '/about': typeof AboutRoute
  '/analytics': typeof AnalyticsRoute
  '/announcements': typeof AnnouncementsRouteWithChildren
  '/classes': typeof ClassesRouteWithChildren
  '/conversation-topics': typeof ConversationTopicsRoute
  '/events': typeof EventsRoute
  '/feedback': typeof FeedbackRouteWithChildren
  '/grammar-videos': typeof GrammarVideosRoute
  '/groups': typeof GroupsRouteWithChildren
  '/identity-reviews': typeof IdentityReviewsRoute
  '/journeys': typeof JourneysRouteWithChildren
  '/learning-paths': typeof LearningPathsRouteWithChildren
  '/products': typeof ProductsRouteWithChildren
  '/students': typeof StudentsRouteWithChildren
  '/units': typeof UnitsRouteWithChildren
  '/women': typeof WomenRouteWithChildren
  '/announcements/$announcementId': typeof AnnouncementsAnnouncementIdRoute
  '/announcements/new': typeof AnnouncementsNewRoute
  '/classes/$classId': typeof ClassesClassIdRoute
  '/classes/new': typeof ClassesNewRoute
  '/feedback/$campaignId': typeof FeedbackCampaignIdRoute
  '/feedback/new': typeof FeedbackNewRoute
  '/groups/$groupId': typeof GroupsGroupIdRoute
  '/groups/new': typeof GroupsNewRoute
  '/journeys/$journeyId': typeof JourneysJourneyIdRoute
  '/journeys/new': typeof JourneysNewRoute
  '/learning-paths/$pathId': typeof LearningPathsPathIdRoute
  '/learning-paths/new': typeof LearningPathsNewRoute
  '/products/$productId': typeof ProductsProductIdRoute
  '/products/new': typeof ProductsNewRoute
  '/students/$studentId': typeof StudentsStudentIdRoute
  '/students/new': typeof StudentsNewRoute
  '/units/$unitId': typeof UnitsUnitIdRoute
  '/units/new': typeof UnitsNewRoute
  '/women/$womanId': typeof WomenWomanIdRoute
  '/women/new': typeof WomenNewRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/app': typeof AppRouteRoute
  '/abilities': typeof AbilitiesRoute
  '/about': typeof AboutRoute
  '/analytics': typeof AnalyticsRoute
  '/announcements': typeof AnnouncementsRouteWithChildren
  '/classes': typeof ClassesRouteWithChildren
  '/conversation-topics': typeof ConversationTopicsRoute
  '/events': typeof EventsRoute
  '/feedback': typeof FeedbackRouteWithChildren
  '/grammar-videos': typeof GrammarVideosRoute
  '/groups': typeof GroupsRouteWithChildren
  '/identity-reviews': typeof IdentityReviewsRoute
  '/journeys': typeof JourneysRouteWithChildren
  '/learning-paths': typeof LearningPathsRouteWithChildren
  '/products': typeof ProductsRouteWithChildren
  '/students': typeof StudentsRouteWithChildren
  '/units': typeof UnitsRouteWithChildren
  '/women': typeof WomenRouteWithChildren
  '/announcements/$announcementId': typeof AnnouncementsAnnouncementIdRoute
  '/announcements/new': typeof AnnouncementsNewRoute
  '/classes/$classId': typeof ClassesClassIdRoute
  '/classes/new': typeof ClassesNewRoute
  '/feedback/$campaignId': typeof FeedbackCampaignIdRoute
  '/feedback/new': typeof FeedbackNewRoute
  '/groups/$groupId': typeof GroupsGroupIdRoute
  '/groups/new': typeof GroupsNewRoute
  '/journeys/$journeyId': typeof JourneysJourneyIdRoute
  '/journeys/new': typeof JourneysNewRoute
  '/learning-paths/$pathId': typeof LearningPathsPathIdRoute
  '/learning-paths/new': typeof LearningPathsNewRoute
  '/products/$productId': typeof ProductsProductIdRoute
  '/products/new': typeof ProductsNewRoute
  '/students/$studentId': typeof StudentsStudentIdRoute
  '/students/new': typeof StudentsNewRoute
  '/units/$unitId': typeof UnitsUnitIdRoute
  '/units/new': typeof UnitsNewRoute
  '/women/$womanId': typeof WomenWomanIdRoute
  '/women/new': typeof WomenNewRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/app'
    | '/abilities'
    | '/about'
    | '/analytics'
    | '/announcements'
    | '/classes'
    | '/conversation-topics'
    | '/events'
    | '/feedback'
    | '/grammar-videos'
    | '/groups'
    | '/identity-reviews'
    | '/journeys'
    | '/learning-paths'
    | '/products'
    | '/students'
    | '/units'
    | '/women'
    | '/announcements/$announcementId'
    | '/announcements/new'
    | '/classes/$classId'
    | '/classes/new'
    | '/feedback/$campaignId'
    | '/feedback/new'
    | '/groups/$groupId'
    | '/groups/new'
    | '/journeys/$journeyId'
    | '/journeys/new'
    | '/learning-paths/$pathId'
    | '/learning-paths/new'
    | '/products/$productId'
    | '/products/new'
    | '/students/$studentId'
    | '/students/new'
    | '/units/$unitId'
    | '/units/new'
    | '/women/$womanId'
    | '/women/new'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/app'
    | '/abilities'
    | '/about'
    | '/analytics'
    | '/announcements'
    | '/classes'
    | '/conversation-topics'
    | '/events'
    | '/feedback'
    | '/grammar-videos'
    | '/groups'
    | '/identity-reviews'
    | '/journeys'
    | '/learning-paths'
    | '/products'
    | '/students'
    | '/units'
    | '/women'
    | '/announcements/$announcementId'
    | '/announcements/new'
    | '/classes/$classId'
    | '/classes/new'
    | '/feedback/$campaignId'
    | '/feedback/new'
    | '/groups/$groupId'
    | '/groups/new'
    | '/journeys/$journeyId'
    | '/journeys/new'
    | '/learning-paths/$pathId'
    | '/learning-paths/new'
    | '/products/$productId'
    | '/products/new'
    | '/students/$studentId'
    | '/students/new'
    | '/units/$unitId'
    | '/units/new'
    | '/women/$womanId'
    | '/women/new'
  id:
    | '__root__'
    | '/'
    | '/app'
    | '/abilities'
    | '/about'
    | '/analytics'
    | '/announcements'
    | '/classes'
    | '/conversation-topics'
    | '/events'
    | '/feedback'
    | '/grammar-videos'
    | '/groups'
    | '/identity-reviews'
    | '/journeys'
    | '/learning-paths'
    | '/products'
    | '/students'
    | '/units'
    | '/women'
    | '/announcements/$announcementId'
    | '/announcements/new'
    | '/classes/$classId'
    | '/classes/new'
    | '/feedback/$campaignId'
    | '/feedback/new'
    | '/groups/$groupId'
    | '/groups/new'
    | '/journeys/$journeyId'
    | '/journeys/new'
    | '/learning-paths/$pathId'
    | '/learning-paths/new'
    | '/products/$productId'
    | '/products/new'
    | '/students/$studentId'
    | '/students/new'
    | '/units/$unitId'
    | '/units/new'
    | '/women/$womanId'
    | '/women/new'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRouteRoute: typeof AppRouteRoute
  AbilitiesRoute: typeof AbilitiesRoute
  AboutRoute: typeof AboutRoute
  AnalyticsRoute: typeof AnalyticsRoute
  AnnouncementsRoute: typeof AnnouncementsRouteWithChildren
  ClassesRoute: typeof ClassesRouteWithChildren
  ConversationTopicsRoute: typeof ConversationTopicsRoute
  EventsRoute: typeof EventsRoute
  FeedbackRoute: typeof FeedbackRouteWithChildren
  GrammarVideosRoute: typeof GrammarVideosRoute
  GroupsRoute: typeof GroupsRouteWithChildren
  IdentityReviewsRoute: typeof IdentityReviewsRoute
  JourneysRoute: typeof JourneysRouteWithChildren
  LearningPathsRoute: typeof LearningPathsRouteWithChildren
  ProductsRoute: typeof ProductsRouteWithChildren
  StudentsRoute: typeof StudentsRouteWithChildren
  UnitsRoute: typeof UnitsRouteWithChildren
  WomenRoute: typeof WomenRouteWithChildren
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRouteRoute: AppRouteRoute,
  AbilitiesRoute: AbilitiesRoute,
  AboutRoute: AboutRoute,
  AnalyticsRoute: AnalyticsRoute,
  AnnouncementsRoute: AnnouncementsRouteWithChildren,
  ClassesRoute: ClassesRouteWithChildren,
  ConversationTopicsRoute: ConversationTopicsRoute,
  EventsRoute: EventsRoute,
  FeedbackRoute: FeedbackRouteWithChildren,
  GrammarVideosRoute: GrammarVideosRoute,
  GroupsRoute: GroupsRouteWithChildren,
  IdentityReviewsRoute: IdentityReviewsRoute,
  JourneysRoute: JourneysRouteWithChildren,
  LearningPathsRoute: LearningPathsRouteWithChildren,
  ProductsRoute: ProductsRouteWithChildren,
  StudentsRoute: StudentsRouteWithChildren,
  UnitsRoute: UnitsRouteWithChildren,
  WomenRoute: WomenRouteWithChildren,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/app",
        "/abilities",
        "/about",
        "/analytics",
        "/announcements",
        "/classes",
        "/conversation-topics",
        "/events",
        "/feedback",
        "/grammar-videos",
        "/groups",
        "/identity-reviews",
        "/journeys",
        "/learning-paths",
        "/products",
        "/students",
        "/units",
        "/women"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/app": {
      "filePath": "app/route.tsx"
    },
    "/abilities": {
      "filePath": "abilities.tsx"
    },
    "/about": {
      "filePath": "about.tsx"
    },
    "/analytics": {
      "filePath": "analytics.tsx"
    },
    "/announcements": {
      "filePath": "announcements.tsx",
      "children": [
        "/announcements/$announcementId",
        "/announcements/new"
      ]
    },
    "/classes": {
      "filePath": "classes.tsx",
      "children": [
        "/classes/$classId",
        "/classes/new"
      ]
    },
    "/conversation-topics": {
      "filePath": "conversation-topics.tsx"
    },
    "/events": {
      "filePath": "events.tsx"
    },
    "/feedback": {
      "filePath": "feedback.tsx",
      "children": [
        "/feedback/$campaignId",
        "/feedback/new"
      ]
    },
    "/grammar-videos": {
      "filePath": "grammar-videos.tsx"
    },
    "/groups": {
      "filePath": "groups.tsx",
      "children": [
        "/groups/$groupId",
        "/groups/new"
      ]
    },
    "/identity-reviews": {
      "filePath": "identity-reviews.tsx"
    },
    "/journeys": {
      "filePath": "journeys.tsx",
      "children": [
        "/journeys/$journeyId",
        "/journeys/new"
      ]
    },
    "/learning-paths": {
      "filePath": "learning-paths.tsx",
      "children": [
        "/learning-paths/$pathId",
        "/learning-paths/new"
      ]
    },
    "/products": {
      "filePath": "products.tsx",
      "children": [
        "/products/$productId",
        "/products/new"
      ]
    },
    "/students": {
      "filePath": "students.tsx",
      "children": [
        "/students/$studentId",
        "/students/new"
      ]
    },
    "/units": {
      "filePath": "units.tsx",
      "children": [
        "/units/$unitId",
        "/units/new"
      ]
    },
    "/women": {
      "filePath": "women.tsx",
      "children": [
        "/women/$womanId",
        "/women/new"
      ]
    },
    "/announcements/$announcementId": {
      "filePath": "announcements/$announcementId.tsx",
      "parent": "/announcements"
    },
    "/announcements/new": {
      "filePath": "announcements/new.tsx",
      "parent": "/announcements"
    },
    "/classes/$classId": {
      "filePath": "classes/$classId.tsx",
      "parent": "/classes"
    },
    "/classes/new": {
      "filePath": "classes/new.tsx",
      "parent": "/classes"
    },
    "/feedback/$campaignId": {
      "filePath": "feedback/$campaignId.tsx",
      "parent": "/feedback"
    },
    "/feedback/new": {
      "filePath": "feedback/new.tsx",
      "parent": "/feedback"
    },
    "/groups/$groupId": {
      "filePath": "groups/$groupId.tsx",
      "parent": "/groups"
    },
    "/groups/new": {
      "filePath": "groups/new.tsx",
      "parent": "/groups"
    },
    "/journeys/$journeyId": {
      "filePath": "journeys/$journeyId.tsx",
      "parent": "/journeys"
    },
    "/journeys/new": {
      "filePath": "journeys/new.tsx",
      "parent": "/journeys"
    },
    "/learning-paths/$pathId": {
      "filePath": "learning-paths/$pathId.tsx",
      "parent": "/learning-paths"
    },
    "/learning-paths/new": {
      "filePath": "learning-paths/new.tsx",
      "parent": "/learning-paths"
    },
    "/products/$productId": {
      "filePath": "products/$productId.tsx",
      "parent": "/products"
    },
    "/products/new": {
      "filePath": "products/new.tsx",
      "parent": "/products"
    },
    "/students/$studentId": {
      "filePath": "students/$studentId.tsx",
      "parent": "/students"
    },
    "/students/new": {
      "filePath": "students/new.tsx",
      "parent": "/students"
    },
    "/units/$unitId": {
      "filePath": "units/$unitId.tsx",
      "parent": "/units"
    },
    "/units/new": {
      "filePath": "units/new.tsx",
      "parent": "/units"
    },
    "/women/$womanId": {
      "filePath": "women/$womanId.tsx",
      "parent": "/women"
    },
    "/women/new": {
      "filePath": "women/new.tsx",
      "parent": "/women"
    }
  }
}
ROUTE_MANIFEST_END */
